import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Restore, Place, WorkOutline } from '@material-ui/icons';
import EndpointImage from '../../static/images/Endpoint.svg';
import RouteImage from '../../static/images/Inspect_Route.svg';
import ServiceImage from '../../static/images/Service.svg';
import PlaceVisitCount from '../../static/images/POI_visit_count.svg';
import RequestImage from '../../static/images/Request.svg';
import VehicleImage from '../../static/images/truck.svg';
import KeyImage from '../../static/images/Key.svg';
import DurationImage from '../../static/images/Duration.svg';
import WorkingTimeImage from '../../static/images/WorkTime.svg';
import * as formatters from '../formatters';
import { HSpacer, SingleLine, Checkbox } from 'sm-react-components';
import * as requests from '../../infrastructure/requests';

const styles = theme => ({
    ellipsis: {
        display: 'inline-block',
        height: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        lineHeight: '1.5'
    }
});

class RequestsInspector extends Component {
  state = {
      keyObj: {}
  };

  componentWillReceiveProps(newProps) {
      const { type, data } = newProps;
      if (type === 'request') {
          this.getKey(data.key.key);
      }
  }

  getKey = async keyId => {
      const key = await requests.getKey(keyId);
      this.setState({ keyObj: key });
  };

  renderRequest = () => {
      const { data, classes } = this.props;
      const { key, response } = data;
      const { keyObj } = this.state;
      let services = undefined;
      let routes = undefined;
      let totalDistance = undefined;
      let totalTime = undefined;
      if (response && response.solution) {
          routes = response.solution.routes.length;
          services = key.metadata.services - response.solution.missing.length;
          totalDistance = response.solution.routes.reduce(
              (p, n) =>
                  p +
          n.steps.reduce(
              (prev, next) => prev + (next.distance ? next.distance : 0),
              0
          ),
              0
          );
          totalTime = response.solution.routes.reduce((p, n) => {
              const arrival = n.steps[n.steps.length - 1].arr_time;
              const departure = n.steps[0].dep_time;
              return p + arrival - departure;
          }, 0);
      }
      return (
          <SingleLine>
              <Fragment>
                  {formatters.icon(RequestImage, 'Request type')}
                  <HSpacer small />
                  <Typography>
                      <b>{formatters.capitalize(key.request)}</b>
                  </Typography>
              </Fragment>

              <Typography className={classes.ellipsis} style={{ maxWidth: '20%' }}>
                  <b>ID: </b>
                  {key.id}
              </Typography>

              <Fragment>
                  {formatters.icon(DurationImage, 'Processing time')}
                  <HSpacer small />
                  <Typography>{formatters.durationMillis(key.duration)}</Typography>
              </Fragment>

              {key.request === 'optimizerV1' && (
                  <Fragment>
                      <Typography>
                          <b>Method: </b>
                          {formatters.requestKind(key.kind, '14px')}
                      </Typography>
                  </Fragment>
              )}

              {key.request === 'optimizerV1' && (
                  <Fragment>
                      {formatters.icon(RouteImage, 'Number of routes')}
                      <HSpacer small />
                      <Typography>{routes || '-'}</Typography>
                  </Fragment>
              )}

              {key.request === 'optimizerV1' && (
                  <Fragment>
                      {formatters.icon(ServiceImage, 'Number of services')}
                      <HSpacer small />
                      <Typography>{services || '-'}</Typography>
                  </Fragment>
              )}
              {(key.request === 'optimizerV1' ||
          key.request === 'placesProfilerV1') && (
                  <Fragment>
                      {formatters.icon(KeyImage, 'API Key')}
                      <HSpacer small />
                      <Typography
                          className={classes.ellipsis}
                          style={{ maxWidth: '10%' }}
                      >
                          {keyObj && keyObj.name}
                      </Typography>
                  </Fragment>
              )}
              {key.request === 'placesProfilerV1' && (
                  <Fragment>
                      {formatters.icon(Place, 'Number of places')}
                      <HSpacer small />
                      <Typography
                          className={classes.ellipsis}
                          style={{ maxWidth: '10%' }}
                      >
                          {response && Object.keys(response.places).length}
                      </Typography>
                  </Fragment>
              )}
              {key.request === 'optimizerV1' && totalDistance && (
                  <Fragment>
                      {formatters.icon(RouteImage, 'Total distance')}
                      <HSpacer small />
                      <Typography
                          className={classes.ellipsis}
                          style={{ maxWidth: '10%' }}
                      >
                          {formatters.distance(totalDistance)}
                      </Typography>
                  </Fragment>
              )}
              {key.request === 'optimizerV1' && totalTime && (
                  <Fragment>
                      {formatters.icon(DurationImage, 'Estimated route duration')}
                      <HSpacer small />
                      <Typography>{formatters.duration(totalTime)}</Typography>
                  </Fragment>
              )}
          </SingleLine>
      );
  };

  renderService = () => {
      const { data, classes } = this.props;
      const timewindows =
      data.timewindows &&
      data.timewindows.reduce(
          (prev, tw, i) =>
              prev +
          `${formatters.timeWindows(tw[0])} - ${formatters.timeWindows(
              tw[1]
          )} ${i !== data.timewindows.length - 1 ? '/ ' : ''}`,
          ''
      );
      const sizes =
      data.size &&
      data.size.reduce(
          (prev, size, i) =>
              prev + `${size} ${i !== data.size.length - 1 ? '/ ' : ''}`,
          ''
      );
      return (
          <SingleLine>
              <Fragment>
                  {formatters.icon(ServiceImage, 'Service')}
                  <HSpacer small />
                  <Typography>
                      <b>{data.type ? formatters.capitalize(data.type) : 'Unassigned'}</b>
                  </Typography>
              </Fragment>

              <Typography className={classes.ellipsis} style={{ maxWidth: '30%' }}>
                  <b>Task ID: </b>
                  {data.id}
              </Typography>

              <Typography>
                  <b>ETA:</b> {formatters.timeSeconds(data.arr_time)}
              </Typography>

              <Fragment>
                  {formatters.icon(VehicleImage, 'Vehicle')}
                  <HSpacer small />
                  <Typography>{data.vehicle || '-'}</Typography>
              </Fragment>

              <Fragment>
                  {formatters.icon(WorkingTimeImage, 'Working time')}
                  <HSpacer small />
                  <Typography>{formatters.timeSeconds(data.duration)}</Typography>
              </Fragment>
              {timewindows && (
                  <Fragment>
                      {formatters.icon(Restore, 'Time window')}
                      <HSpacer small />
                      <Typography>{timewindows}</Typography>
                  </Fragment>
              )}
              {sizes && (
                  <Fragment>
                      {formatters.icon(WorkOutline, 'Size')}
                      <HSpacer small />
                      <Typography>{sizes}</Typography>
                  </Fragment>
              )}
          </SingleLine>
      );
  };

  renderEndpoint = () => {
      const { data } = this.props;
      return (
          <SingleLine>
              <Fragment>
                  {formatters.icon(EndpointImage, 'Endpoint')}
                  <HSpacer small />
                  <Typography>
                      <b>{formatters.capitalize(data.type)}</b>
                  </Typography>
              </Fragment>

              <Fragment>
                  {formatters.icon(VehicleImage, 'Vehicle')}
                  <HSpacer small />
                  <Typography>{data.vehicle}</Typography>
              </Fragment>

              {data.type === 'end' && (
                  <Fragment>
                      {formatters.icon(DurationImage, 'Estimated time arrival')}
                      <HSpacer small />
                      <Typography>
                          <b>arrival:</b> {formatters.timeSeconds(data.arr_time)}
                      </Typography>
                  </Fragment>
              )}

              {data.type === 'start' && (
                  <Fragment>
                      {formatters.icon(DurationImage, 'Estimated time departure')}
                      <HSpacer small />
                      <Typography>
                          <b>departure:</b> {formatters.timeSeconds(data.dep_time)}
                      </Typography>
                  </Fragment>
              )}
          </SingleLine>
      );
  };

  renderPoi = () => {
      const { data } = this.props;
      if (data.type === 'start' || data.type === 'end') {
          return this.renderEndpoint();
      } else {
          return this.renderService();
      }
  };

  renderRoute = () => {
      const { data, classes } = this.props;
      const arrival = data.steps[data.steps.length - 1].arr_time;
      const departure = data.steps[0].dep_time;
      return (
          <SingleLine>
              <Fragment>
                  {formatters.icon(RouteImage, 'Route')}
                  <HSpacer small />
                  <Typography>
                      <b>Route</b>
                  </Typography>
              </Fragment>

              <Fragment>
                  {formatters.icon(VehicleImage, 'Vehicle')}
                  <HSpacer small />
                  <Typography className={classes.ellipsis} style={{ maxWidth: '15%' }}>
                      {data.vehicle_id}
                  </Typography>
              </Fragment>

              <Fragment>
                  {formatters.icon(DurationImage, 'Estimated route duration')}
                  <HSpacer small />
                  <Typography>{formatters.duration(arrival - departure)}</Typography>
              </Fragment>

              <Typography>
                  <b>Start time: </b>
                  {formatters.timeSeconds(departure)}
              </Typography>

              <Typography>
                  <b>End time: </b>
                  {formatters.timeSeconds(arrival)}
              </Typography>

              <Typography>
                  <b>Distance: </b>
                  {formatters.distance(data.distance)}
              </Typography>
          </SingleLine>
      );
  };

  renderPlace = () => {
      const { data, classes } = this.props;
      return (
          <SingleLine>
              <Fragment>
                  {formatters.icon(Place, 'Place')}
                  <HSpacer small />
                  <Typography>
                      <b>Place</b>
                  </Typography>
              </Fragment>
              <Typography className={classes.ellipsis} style={{ maxWidth: '20%' }}>
                  <b>ID: </b>
                  {data.id}
              </Typography>
              <Fragment>
                  {formatters.icon(PlaceVisitCount, 'Visit count')}
                  <HSpacer small />
                  <Typography>{data.visitcount}</Typography>
              </Fragment>

              <Fragment>
                  {formatters.icon(DurationImage, 'Stop time')}
                  <HSpacer small />
                  <Typography>{formatters.duration(data.duration)}</Typography>
              </Fragment>

              {data.timewindows && data.timewindows.length > 0 && (
                  <Fragment>
                      {formatters.icon(Restore, 'Time windows')}
                      <HSpacer small />
                      <Typography>
                          {formatters.arrayTimewindowsToString(data.timewindows)}
                      </Typography>
                  </Fragment>
              )}
          </SingleLine>
      );
  };

  renderRouteGPS = () => {
      const { data, classes } = this.props;
      return (
          <SingleLine>
              <Fragment>
                  {formatters.icon(RouteImage, 'Route')}
                  <HSpacer small />
                  <Typography>
                      <b>Route</b>
                  </Typography>
              </Fragment>

              <Fragment>
                  {formatters.icon(VehicleImage, 'Vehicle')}
                  <HSpacer small />
                  <Typography className={classes.ellipsis} style={{ maxWidth: '15%' }}>
                      {data.id}
                  </Typography>
              </Fragment>

              <Fragment>
                  {formatters.icon(DurationImage, 'Duration')}
                  <HSpacer small />
                  <Typography>{formatters.duration(data.duration)}</Typography>
              </Fragment>
          </SingleLine>
      );
  };

  renderPlacesWithSelection = () => {
      const { data } = this.props;
      return (
          <SingleLine>
              <Fragment>
                  {formatters.icon(Place, 'Place')}
                  <HSpacer small />
                  <Typography>{data.count} places</Typography>
              </Fragment>
              <Fragment>
                  <Checkbox
                      id="Visited"
                      checked={data.visited.checkboxVisited}
                      onChange={data.visited.onChange}
                  />
                  <HSpacer small />
                  <Typography>{data.visited.label} places</Typography>
              </Fragment>
              <Fragment>
                  <Checkbox
                      id="Unvisited"
                      checked={data.unvisited.checkboxUnvisited}
                      onChange={data.unvisited.onChange}
                  />
                  <HSpacer small />
                  <Typography>{data.unvisited.label} places</Typography>
              </Fragment>
          </SingleLine>
      );
  };

  render() {
      const { type } = this.props;
      return (
      <>
        {type === 'request' && this.renderRequest()}
        {type === 'poi' && this.renderPoi()}
        {type === 'route' && this.renderRoute()}
        {type === 'place' && this.renderPlace()}
        {type === 'routeGPS' && this.renderRouteGPS()}
        {type === 'placesWithSelection' && this.renderPlacesWithSelection()}
      </>
      );
  }
}

export default withStyles(styles)(RequestsInspector);
